<template>
  <div>
    <base-title
      :title="'Clientes cadastrados'"
      :subtitle="StringLanguage.reports"
      :link="'relatorios'"
    />

    <div class="tabs mb_25">
      <ul>
        <!-- <li>
          <a @click="selectedTab = 0" :class="{ active: selectedTab === 0 }">{{
            StringLanguage.overview
          }}</a>
        </li> -->
        <li>
          <a @click="selectedTab = 1" :class="{ active: selectedTab === 1 }">{{
            StringLanguage.detailing
          }}</a>
        </li>
      </ul>
    </div>

    <!-- <div v-if="selectedTab === 0">
      <customers-report-dashboard
        :showLoading="showFirstComponentLoading"
        :showItem="showItem"
      />
    </div> -->

    <div v-if="selectedTab === 1">
      <customers-report-detail />
    </div>
  </div>
</template>
<script>
// components
import { mapState } from 'vuex';
import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';
import CustomersReportDetail from './CustomersReportDetail';
import CustomersReportDashboard from './CustomersReportDashboard';

export default {
  components: {
    BaseTitle,
    BaseButton,
    CustomersReportDetail,
    CustomersReportDashboard,
  },
  data() {
    return {
      selectedTab: 1,
      showFirstComponentLoading: true,
      showItem: false,
    };
  },
  watch: {
    selectedTab: {
      deep: true,
      handler(newValue, oldValue) {
        this.showItem = true;
        if (newValue === 0 && oldValue === 1) {
          this.showFirstComponentLoading = true;
        }
      },
    },
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
    }),
  },
};
</script>
<style scoped>
.tabs ul li {
  display: inline;
  text-align: center;
}
.tabs a {
  cursor: pointer;
  display: inline-block;
  margin-right: 25px;
  margin-bottom: 6px;
  text-decoration: none;
  font-size: 1.4em;
  color: #999999ad;
  padding-bottom: 5px;
  border-bottom: 2px solid transparent;
}
.tabs a.active {
  color: var(--default);
  border-color: var(--default);
}
@media screen and (max-width: 991px) {
  .tabs ul {
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
  }
}
</style>
